const processInclude = require('app_storefront_base/util');

window.onjQueryLoad(function () {
    processInclude(require('plugin_frontend_components/product/product-carousel'));
}, true);

